import * as React from "react";
import { Stack as MantineStack } from "@mantine/core";
const Stack = ({ ...props }) => /* @__PURE__ */ React.createElement(MantineStack, { ...props });
export default Stack;
